/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import { Signer, BigNumberish } from "ethers";
import { Provider, TransactionRequest } from "@ethersproject/providers";
import { Contract, ContractFactory, Overrides } from "@ethersproject/contracts";

import type { Orbit } from "../Orbit";

export class Orbit__factory extends ContractFactory {
  constructor(signer?: Signer) {
    super(_abi, _bytecode, signer);
  }

  deploy(
    _registry: string,
    _platformFee: BigNumberish,
    overrides?: Overrides
  ): Promise<Orbit> {
    return super.deploy(
      _registry,
      _platformFee,
      overrides || {}
    ) as Promise<Orbit>;
  }
  getDeployTransaction(
    _registry: string,
    _platformFee: BigNumberish,
    overrides?: Overrides
  ): TransactionRequest {
    return super.getDeployTransaction(_registry, _platformFee, overrides || {});
  }
  attach(address: string): Orbit {
    return super.attach(address) as Orbit;
  }
  connect(signer: Signer): Orbit__factory {
    return super.connect(signer) as Orbit__factory;
  }
  static connect(address: string, signerOrProvider: Signer | Provider): Orbit {
    return new Contract(address, _abi, signerOrProvider) as Orbit;
  }
}

const _abi = [
  {
    inputs: [
      {
        internalType: "address",
        name: "_registry",
        type: "address",
      },
      {
        internalType: "uint16",
        name: "_platformFee",
        type: "uint16",
      },
    ],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "creator",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "nft",
        type: "address",
      },
    ],
    name: "CollectionOfferCanceled",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "creator",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "nft",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "quantity",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "address",
        name: "payToken",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "pricePerItem",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "deadline",
        type: "uint256",
      },
    ],
    name: "CollectionOfferCreated",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "nft",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "ItemCanceled",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "nft",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "quantity",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "address",
        name: "payToken",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "pricePerItem",
        type: "uint256",
      },
    ],
    name: "ItemListed",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "seller",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "buyer",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "nft",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "quantity",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "address",
        name: "payToken",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "pricePerItem",
        type: "uint256",
      },
    ],
    name: "ItemSold",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "nft",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "address",
        name: "payToken",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "newPrice",
        type: "uint256",
      },
    ],
    name: "ItemUpdated",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "creator",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "nft",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "OfferCanceled",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "creator",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "nft",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "quantity",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "address",
        name: "payToken",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "pricePerItem",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "deadline",
        type: "uint256",
      },
    ],
    name: "OfferCreated",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "Paused",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        indexed: true,
        internalType: "bytes32",
        name: "previousAdminRole",
        type: "bytes32",
      },
      {
        indexed: true,
        internalType: "bytes32",
        name: "newAdminRole",
        type: "bytes32",
      },
    ],
    name: "RoleAdminChanged",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        indexed: true,
        internalType: "address",
        name: "account",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "sender",
        type: "address",
      },
    ],
    name: "RoleGranted",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        indexed: true,
        internalType: "address",
        name: "account",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "sender",
        type: "address",
      },
    ],
    name: "RoleRevoked",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "Unpaused",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint16",
        name: "platformFee",
        type: "uint16",
      },
    ],
    name: "UpdatePlatformFee",
    type: "event",
  },
  {
    inputs: [],
    name: "DEFAULT_ADMIN_ROLE",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_nftAddress",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "_tokenId",
        type: "uint256",
      },
      {
        internalType: "address",
        name: "_creator",
        type: "address",
      },
    ],
    name: "acceptCollectionOffer",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_nftAddress",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "_tokenId",
        type: "uint256",
      },
      {
        internalType: "address",
        name: "_creator",
        type: "address",
      },
    ],
    name: "acceptOffer",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "addressRegistry",
    outputs: [
      {
        internalType: "contract IOrbitAddressRegistry",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_tokenContract",
        type: "address",
      },
    ],
    name: "approveERC20ForRewards",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_nftAddress",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "_tokenId",
        type: "uint256",
      },
      {
        internalType: "address",
        name: "_payToken",
        type: "address",
      },
      {
        internalType: "address",
        name: "_owner",
        type: "address",
      },
    ],
    name: "buyItem",
    outputs: [],
    stateMutability: "payable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_nftAddress",
        type: "address",
      },
    ],
    name: "cancelCollectionOffer",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_nftAddress",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "_tokenId",
        type: "uint256",
      },
    ],
    name: "cancelListing",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_nftAddress",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "_tokenId",
        type: "uint256",
      },
    ],
    name: "cancelOffer",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    name: "collectionOffers",
    outputs: [
      {
        internalType: "contract IERC20",
        name: "payToken",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "quantity",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "pricePerItem",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "deadline",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_nftAddress",
        type: "address",
      },
      {
        internalType: "contract IERC20",
        name: "_payToken",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "_quantity",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "_pricePerItem",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "_deadline",
        type: "uint256",
      },
    ],
    name: "createCollectionOffer",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_nftAddress",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "_tokenId",
        type: "uint256",
      },
      {
        internalType: "contract IERC20",
        name: "_payToken",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "_quantity",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "_pricePerItem",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "_deadline",
        type: "uint256",
      },
    ],
    name: "createOffer",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
    ],
    name: "getRoleAdmin",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        internalType: "uint256",
        name: "index",
        type: "uint256",
      },
    ],
    name: "getRoleMember",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
    ],
    name: "getRoleMemberCount",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "grantRole",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "hasRole",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_nftAddress",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "_tokenId",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "_quantity",
        type: "uint256",
      },
      {
        internalType: "address",
        name: "_payToken",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "_pricePerItem",
        type: "uint256",
      },
    ],
    name: "listItem",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    name: "listings",
    outputs: [
      {
        internalType: "uint256",
        name: "quantity",
        type: "uint256",
      },
      {
        internalType: "address",
        name: "payToken",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "pricePerItem",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "maxOfferExpiry",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    name: "offers",
    outputs: [
      {
        internalType: "contract IERC20",
        name: "payToken",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "quantity",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "pricePerItem",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "deadline",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "pauseMarketplace",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "paused",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "platformFee",
    outputs: [
      {
        internalType: "uint16",
        name: "",
        type: "uint16",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "reclaimBalance",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_tokenContract",
        type: "address",
      },
    ],
    name: "reclaimERC20",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_nftAddress",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "_tokenId",
        type: "uint256",
      },
    ],
    name: "reclaimNFT",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "renounceRole",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "revokeRole",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    name: "royalties",
    outputs: [
      {
        internalType: "uint16",
        name: "",
        type: "uint16",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes4",
        name: "interfaceId",
        type: "bytes4",
      },
    ],
    name: "supportsInterface",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "unpauseMarketplace",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_registry",
        type: "address",
      },
    ],
    name: "updateAddressRegistry",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_nftAddress",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "_tokenId",
        type: "uint256",
      },
      {
        internalType: "address",
        name: "_payToken",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "_newPrice",
        type: "uint256",
      },
    ],
    name: "updateListing",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_maxOfferExpiry",
        type: "uint256",
      },
    ],
    name: "updateMaxOfferExpiry",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint16",
        name: "_platformFee",
        type: "uint16",
      },
    ],
    name: "updatePlatformFee",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    stateMutability: "payable",
    type: "receive",
  },
];

const _bytecode =
  "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";
